import LegalPageLayout from "@/components/legal/LegalPageLayout";

export default function Privacy() {
  return (
    <LegalPageLayout title="Privacy Policy" testId="privacy-page">
      <p>
        Animal Matter To Me ("AMTM", "we", "us") respects your privacy. This policy explains what information we
        collect when you visit this Site or make a donation, and how we use it.
      </p>

      <h2>1. Information we collect</h2>
      <p>
        When you donate or contact us, we collect your name, email address, phone number, and - only if you
        choose to provide it - your PAN (for 80G tax exemption purposes). We do not collect or store your card,
        UPI, or bank details; these are handled directly by our payment processor, Razorpay.
      </p>

      <h2>2. How we use your information</h2>
      <p>
        We use your information to process your donation, issue your 80G donation receipt, send you
        donation-related communications (such as a receipt, a welcome message if you become a Guardian, or a
        payment-issue notice), and to comply with our legal and regulatory obligations as a registered NGO.
      </p>

      <h2>3. Third-party processors</h2>
      <p>
        We share the minimum necessary information with Razorpay to process your payment, and with our
        transactional email provider to deliver receipts and donation-related emails. We do not sell your
        information to anyone.
      </p>

      <h2>4. Cookies and analytics</h2>
      <p>
        This Site may use standard analytics tools to understand how visitors use it, so we can improve the
        donation experience. Any such tracking will be disclosed here as it is introduced.
      </p>

      <h2>5. Data retention</h2>
      <p>
        We retain donor records for as long as required for accounting, tax, and regulatory compliance under
        Indian law (including 80G/12AB record-keeping requirements).
      </p>

      <h2>6. Your rights</h2>
      <p>
        You may write to us at any time to access, correct, or request deletion of your personal information,
        subject to our legal record-keeping obligations. See our <a href="/contact">Contact Us</a> page.
      </p>

      <h2>7. Security</h2>
      <p>
        We use industry-standard measures, including processing all payments through PCI-DSS compliant Razorpay
        checkout, to protect your information.
      </p>

      <h2>8. Changes to this policy</h2>
      <p>We may update this policy from time to time; the current version will always be published on this page.</p>
    </LegalPageLayout>
  );
}
